// @flow
import { renderToString } from "react-dom/server";

import { Provider } from "react-redux";

import { ServerStyleSheet, StyleSheetManager } from "styled-components";
import ThemeProvider from "../react-theme/ThemeProvider";

import { getBasePathServer } from "../constants/Settings";

import { createHead, dehydrate } from "./serverUtil";
import htmlpage from "./htmlpage";

import type { Theme } from "../react-theme/types";
import type { ReduxStore } from "../redux/types";
import type { TemplateProps } from "./htmlpage";
type Props = {
  store: ReduxStore,
  theme?: Theme | Array<Theme>,
  UUID: string,
  render: Function,
  template?: (TemplateProps) => string,
};

/**
 */
const renderSSRMinimal = ({
  store,
  theme,
  UUID = "",
  render,
  template = htmlpage,
}: Props): string => {
  const sheet = new ServerStyleSheet();

  const appHTML = renderToString(
    <Provider store={store}>
      <StyleSheetManager sheet={sheet.instance}>
        <ThemeProvider theme={theme}>{render()}</ThemeProvider>
      </StyleSheetManager>
    </Provider>,
  );

  const head = createHead(sheet, UUID);
  return template({
    contextPath: getBasePathServer(),
    html: appHTML,
    head,
    state: dehydrate(store),
    UUID,
  });
};

export default renderSSRMinimal;
